import httpClient from "../../clients/httpClient";
import {
    IIntegrationTemplatePayload,
    IIntegrationTemplateUpdatePayload,
} from "../../interfaces/integration-template.interface";

export const getOrganizationIntegrationTemplates = () => {
    return httpClient.get(`/api/v1/integration-templates`);
};

export const getIntegrationTemplates = () => {
    return httpClient.get(`/api/v1/admin/integration-templates`);
};

// Templates with sandbox values only, recommended first, then alphabetical.
export const getSandboxIntegrationTemplates = () => {
    return httpClient.get(`/api/v1/admin/integration-templates`, {
        params: { has_sandbox: 1 },
    });
};

export const getIntegrationTemplateRequest = (id: string) => {
    return httpClient.get(`/api/v1/admin/integration-templates/${id}`);
};

export const storeIntegrationTemplateRequest = (
    payload: IIntegrationTemplatePayload
) => {
    return httpClient.post("/api/v1/admin/integration-templates", payload);
};

export const updateIntegrationTemplateRequest = (
    id: number,
    payload: IIntegrationTemplateUpdatePayload
) => {
    return httpClient.patch(
        `/api/v1/admin/integration-templates/${id}`,
        payload
    );
};

export const deleteIntegrationTemplate = (id: number) => {
    return httpClient.delete(`/api/v1/admin/integration-templates/${id}`);
};
